import { action, makeObservable, observable } from 'mobx';

import ApiService from '../../services/ApiService';
import { InvoiceDeliveryLog } from '../models/InvoiceDeliveryLog';
import { Loadable } from '../models/Loadable';
import { ISsoStore } from '../SsoStore';

export default class InvoiceDeliveryLogDataStore {
  @observable
  public deliveryLogs: Map<string, Loadable<InvoiceDeliveryLog[]>> = new Map();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore
  ) {
    makeObservable(this);
  }

  @action
  public async tryLoadInvoiceDeliveryLog(invoiceNumber: string): Promise<any> {
    if (this.deliveryLogs.has(invoiceNumber)) {
      await this.deliveryLogs.get(invoiceNumber).promise;
      return;
    }

    const deliveryLogPromise = this.apiService.getInvoiceDeliveryLog(this.ssoStore.customer.customerId, invoiceNumber);
    this.deliveryLogs.set(invoiceNumber, Loadable.toLoadable(deliveryLogPromise));
    await deliveryLogPromise;
  }
}
